<template>
  <div class="separator-container" ref="container">
    <div class="separator-gradient"></div>
    <div :class="['separator-line', orientation]"></div>
  </div>
</template>

<script>
export default {
  name: "Separator",
  props: {
    orientation: {
      type: String,
      default: "horizontal",
      validator: (value) => ["horizontal", "vertical"].includes(value),
    },
    thickness: {
      type: Number,
      default: 1,
    },
    length: {
      type: String,
      default: "100%",
    },
  },
  mounted() {
    const container = this.$refs.container;
    const gradient = container.querySelector(".separator-gradient");

    container.addEventListener("mousemove", (e) => {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const gradientX = (x / rect.width) * 100;
      const gradientY = (y / rect.height) * 100;

      gradient.style.background = `
        radial-gradient(
          200px circle at ${gradientX}% ${gradientY}%, 
          rgba(255, 102, 102, 0.7),
          rgba(255, 160, 104, 0.7),
          transparent 40%
        )
      `;
      gradient.style.opacity = "1";
    });

    container.addEventListener("mouseleave", () => {
      gradient.style.opacity = "0";
    });
  },
};
</script>

<style scoped>
.separator-container {
  position: relative;
  display: inline-block;
}

.separator-gradient {
  position: absolute;
  inset: -20px;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.separator-line {
  position: relative;
  background: rgba(255, 255, 255, 0.1);
}

.horizontal {
  width: v-bind(length);
  height: v-bind(thickness + "px");
}

.vertical {
  height: v-bind(length);
  width: v-bind(thickness + "px");
}

@media (prefers-color-scheme: dark) {
  .separator-line {
    background: rgba(255, 255, 255, 0.1);
  }
}
</style>
